/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_data_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do file transfer speeds feel slower than my internet plan's advertised number?`)
};

const es_uc_data_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué las velocidades de transferencia de archivos se sienten más lentas que el número anunciado de mi plan de internet?`)
};

const de_uc_data_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum wirken Dateiübertragungsgeschwindigkeiten langsamer als die beworbene Zahl meines Internettarifs?`)
};

const nl_uc_data_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom voelen bestandsoverdrachtsnelheden trager aan dan mijn internetplan adverteert nummer?`)
};

const fr_uc_data_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les vitesses de transfert de fichiers semblent-elles plus lentes que le nombre annoncé de mon plan Internet ?`)
};

const it_uc_data_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché le velocità di trasferimento file si sentono più lente del numero pubblicizzato del mio piano internet?`)
};

const pt_br2_uc_data_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que as velocidades de transferência de arquivos parecem mais lentas do que o número anunciado no meu plano de internet?`)
};

const pt_uc_data_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que as velocidades de transferência de ficheiros se sentem mais lentas do que o número anunciado do meu plano de internet?`)
};

const ja_uc_data_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜファイル転送速度はインターネット計画の宣伝数字より遅く感じますか?`)
};

const zh_uc_data_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_data_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_data_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_data_faq4_q", locale)
	if (locale === "en") return en_uc_data_faq4_q(inputs)
	if (locale === "es") return es_uc_data_faq4_q(inputs)
	if (locale === "de") return de_uc_data_faq4_q(inputs)
	if (locale === "nl") return nl_uc_data_faq4_q(inputs)
	if (locale === "fr") return fr_uc_data_faq4_q(inputs)
	if (locale === "it") return it_uc_data_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_data_faq4_q(inputs)
	if (locale === "pt") return pt_uc_data_faq4_q(inputs)
	if (locale === "ja") return ja_uc_data_faq4_q(inputs)
	return zh_uc_data_faq4_q(inputs)
};